import { render, staticRenderFns } from "./cutOffLine.vue?vue&type=template&id=0fb61dfb&scoped=true"
import script from "./cutOffLine.vue?vue&type=script&lang=ts"
export * from "./cutOffLine.vue?vue&type=script&lang=ts"
import style0 from "./cutOffLine.vue?vue&type=style&index=0&id=0fb61dfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb61dfb",
  null
  
)

export default component.exports